module.exports = __webpack_public_path__ + "static/media/Dra-Maria-De-Las-Mercedes-Miralles.903569af.jpg";